import { useState } from 'react';

import endpoints from '../../../../../../../../../api/endpoints';
import { BusinessError } from '../../../../../../../../common/business-error';
import { handleResponseError } from '../../../../../../../../../api/handleResponseError';
import { fetchWithTokenRefresh } from '../../../../../../../../../api/fetchWithTokenRefresh';

import { getOtpVerifyBusinessError } from '../businessErrors';

type DialogError = BusinessError | null;

export const useNewSecretsRequest = () => {
  const [newSecretsRequestLoading, setLoading] = useState<boolean>(false);
  const [newSecretsRequestError, setError] = useState<DialogError>(null);

  const handleRecreateSecretsRequest = async (onSuccess: () => void) => {
    try {
      setLoading(true);
      const response = await fetchWithTokenRefresh(endpoints.clientRegenerateSecretsOrder, { method: 'POST' });
      if (response.status !== 200) {
        await handleResponseError(response);
      }

      onSuccess();
    } catch (e) {
      const { message, severity } = getOtpVerifyBusinessError(e);

      setError({ message, severity });
      setLoading(false);
    }
  };

  return { newSecretsRequestError, newSecretsRequestLoading, handleRecreateSecretsRequest };
};
